import { getBookImage, handleBookImageError } from '../../utils';
import StockOverlay from '../common/StockOverlay';

const QuickViewImage = ({ book, discount }) => (
  <div className="md:col-span-2 relative bg-gradient-to-br from-orange-50 via-amber-50 to-rose-50 flex items-center justify-center p-6 sm:p-8 md:p-10 min-h-[280px] md:min-h-[480px]">
    {discount > 0 && (
      <span className="absolute top-4 left-4 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg">
        {discount}% OFF
      </span>
    )}
    {book.bestseller && (
      <span className="absolute top-4 right-16 bg-gradient-to-r from-amber-400 to-yellow-500 text-white text-[10px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full shadow">
        Bestseller
      </span>
    )}
    <img
      src={getBookImage(book.image)}
      onError={handleBookImageError}
      alt={book.title}
      className="max-h-64 md:max-h-80 w-auto object-contain drop-shadow-2xl rounded-md transition-transform hover:scale-105 duration-300"
      loading="lazy"
    />
    <StockOverlay stock={book.stock} />
  </div>
);

export default QuickViewImage;
